// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"CampaignsNavList_listContainer__1eH2c","avatar":"CampaignsNavList_avatar__KlQpp"};